// PageErrorContext.tsx
import { createContext, useContext } from "react";
import { FormErrorsState } from "../../types/types";

export type PageErrorContextType = {
  formErrors: FormErrorsState | null;
  setFormErrors: (errors: FormErrorsState | null) => void;
  mapAndSetErrors: (error: unknown) => void;
  clearErrors: () => void;
};

export const PageErrorContext = createContext<PageErrorContextType | undefined>(
  undefined
);

export const usePageErrors = () => {
  const ctx = useContext(PageErrorContext);
  if (!ctx) {
    throw new Error("usePageErrors must be inside <PageErrorProvider>");
  }
  return ctx;
};
